export const COMPANY = {
  legalName: 'Yubero Moreno Agentes Financieros S.L.',
  shortName: 'Yubero Moreno',
  descriptor: {
    es: 'Agentes Financieros',
    en: 'Financial Agents',
  },
  address: {
    street: 'Calle Segovia, 8',
    town: 'Navas de San Antonio',
    postcode: '40408',
    province: 'Segovia',
    country: { es: 'España', en: 'Spain' },
  },
  addressLine: 'Calle Segovia, 8, Navas de San Antonio, 40408 Segovia',
  cif: 'B10641041',
  vat: 'ESB10641041',
  phone: '+34 849 060 028',
  phoneHref: '+34849060028',
  email: 'info@fundingreferrals.net',
}

export const ADDRESS_FULL = {
  es: `${COMPANY.addressLine}, España`,
  en: `${COMPANY.addressLine}, Spain`,
}
